import { api } from "utils/apiClient";
import {
  NOTIFICATION_LIMIT,
  TypeNotification,
  UserType,
} from "utils/constants";

const path = (id) => `/notifications/${encodeURIComponent(id)}`;

// A page of notifications, newest first, as { items, nextToken }.
const page = async (type, nextToken) => {
  const { items, nextCursor } = await api("GET", "/notifications", {
    query: { type, limit: NOTIFICATION_LIMIT, cursor: nextToken },
  });
  return { items, nextToken: nextCursor || "" };
};

export class NotificationService {
  constructor(loginData) {
    this._loginData = loginData;
    this._isSPUser = this._loginData.type == UserType.NTTsp;
  }

  // The caller's own notifications (the BE picks NTT or OEM); the NTT admin
  // writes both, so it gets the first page of each.
  async getListNotification(nextToken = "") {
    if (!this._isSPUser) return page(undefined, nextToken);

    const [ntt, oem] = await Promise.all([
      page(TypeNotification.NTT, nextToken),
      page(TypeNotification.OEM, nextToken),
    ]);
    return {
      items: [...ntt.items, ...oem.items],
      nextToken: oem.nextToken || ntt.nextToken,
    };
  }

  // One audience, for the NTT admin's tabs; other callers may only read their own.
  async getListNotificationNTT(nextToken = "") {
    return page(this._isSPUser ? TypeNotification.NTT : undefined, nextToken);
  }

  async getListNotificationOEM(nextToken = "") {
    return page(this._isSPUser ? TypeNotification.OEM : undefined, nextToken);
  }

  async createNewNotification({ title, target, redirectURL }) {
    if (!this._isSPUser) return;
    return api("POST", "/notifications", {
      query: { type: target },
      body: { title, target, redirectURL },
    });
  }

  // An edit clears readBy on the server, so it shows as unread again.
  async updateNotification({ id, title, target, redirectURL }) {
    if (!this._isSPUser) return;
    return api("PATCH", path(id), {
      query: { type: target },
      body: { title, redirectURL },
    });
  }

  async deleteNotification({ id, target }) {
    if (!this._isSPUser) return;
    await api("DELETE", path(id), { query: { type: target } });
    return { id };
  }
}
